export default __webpack_public_path__ + "static/web_wireframe_cover-d5d4912fd399c47b8a81b1966ab856b3.png";